import { useCallback } from 'react';
import { useSchedulePulseShallowStore } from '../../../../../../stores/schedule-pulse.store';

type UseOpenedRequestDetailsProps = {
  requestId: string | undefined;
  locationId: string | undefined;
};

export const useOpenedRequestDetails = ({ requestId, locationId }: UseOpenedRequestDetailsProps) => {
  const { selectedRequestId, selectedRequestLocationId } = useSchedulePulseShallowStore(
    'selectedRequestId',
    'selectedRequestLocationId'
  );

  const accordionRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        if (selectedRequestId === requestId && selectedRequestLocationId === locationId) {
          node.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    [selectedRequestId, selectedRequestLocationId, requestId, locationId]
  );

  return { accordionRef };
};
